import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { API_URL } from "..";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import Swal from "sweetalert2";
import Switch from "react-switch";
import {
  GoogleMap,
  Marker,
  Circle,
  useLoadScript,
} from "@react-google-maps/api";

// Mapbox access token
const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ";
const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "8px",
  border: "1px solid #ced4da",
};

const defaultCenter = { lat: 51.5074, lng: -0.1276 };

const EditAppointmentPage = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyBtQlR_uF7q-S8TQblCzLw7Fy7BvyIeXAg",
    libraries: ["places"],
  });

  const { id } = useParams();
  const [electricianList, setElectricianList] = useState([]);
  const [workforceList, setWorkforceList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [electricianListSelect, setElectricianListSelect] = useState([]);
  const [workforceListSelect, setWorkforceListSelect] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerType, setCustomerType] = useState("existing");
  const [enableGeofencing, setEnableGeofencing] = useState(false);
  const [radius, setRadius] = useState(100);
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const [markerPosition, setMarkerPosition] = useState(null);
  const [jobDateSet, setJobDateSet] = useState(
    new Date().toISOString().slice(0, 16)
  );
  const [completetionTesting, setCompletionReport] = useState({
    patTesting: false,
    certificateIssue:false,
  });
  
  const [formData, setFormData] = useState({
    address: "",
    postcode: "",
    job_cost: "",
    description: "",
    furtherDescription: "",
    latitude: "",
    longitude: "",
    referenceNo: "",
  });
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [errors, setErrors] = useState({});
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const addressInputRef = useRef(null);
  const descriptionQuillRef = useRef(null);
  const descriptionEditorRef = useRef(null);
  const furtherQuillRef = useRef(null);
  const furtherEditorRef = useRef(null);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.referenceNo) {
      newErrors.referenceNo = "Reference No is required";
    }
    if (!formData.address) {
      newErrors.address = "Job Address is required";
    }
    if (selectedServices.length === 0) {
      newErrors.services = "At least one service is required";
    }
    if (electricianListSelect.length === 0) {
      newErrors.electricians = "At least one electrician is required";
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Fetch electricians
  const fetchElectrician = async () => {
    try {
      const response = await fetch(`${API_URL}/api/user/fetch-electrician`, {
        method: "GET",
        headers: { Accept: "*/*", "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (response.status === 200) {
        setElectricianList(data.data.map((e) => ({ label: e.name, value: e.id })));
      }
    } catch (error) {
      console.error("Error fetching electricians:", error);
    }
  };

  // Fetch workforce
  

  const [jobLocationCoordinates, setJobLocationCoordinates] = useState(null);
  const [isJobLocationCustomerAddress, setIsJobLocationCustomerAddress] = useState(true);

  useEffect(() => {
    if (isJobLocationCustomerAddress && formData.latitude && formData.longitude) {
      setMarkerPosition({
        lat: parseFloat(formData.latitude),
        lng: parseFloat(formData.longitude),
      });
      setMapCenter({
        lat: parseFloat(formData.latitude),
        lng: parseFloat(formData.longitude),
      });
    } else if (!isJobLocationCustomerAddress && jobLocationCoordinates) {
      setMarkerPosition({
        lat: jobLocationCoordinates.latitude,
        lng: jobLocationCoordinates.longitude,
      });
      setMapCenter({
        lat: jobLocationCoordinates.latitude,
        lng: jobLocationCoordinates.longitude,
      });
    }
  }, [formData.latitude, formData.longitude, jobLocationCoordinates, isJobLocationCustomerAddress, radius]);

  // Fetch customers
  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${API_URL}/api/customer/fetch`, {
        method: "GET",
        headers: { Accept: "*/*", "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (response.status === 201) {
        setCustomerList(
          data.customer.map((e) => ({
            label: e.name,
            value: e.id,
            name: e.name,
            email: e.email,
            phone: e.phone,
            address: e.address,
            postcode: e.postcode,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  // Fetch services
  const fetchServices = async () => {
    try {
      const response = await fetch(`${API_URL}/api/service`, {
        method: "GET",
        headers: { Accept: "*/*", "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (response.status === 200) {
        setServiceOptions(
          data.map((service) => ({
            label: service.title,
            value: service.title,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const fetchCoordinates = async (address) => {
    if (!address) return { latitude: "", longitude: "" };
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          address
        )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB`
      );
      const data = await response.json();
      if (data.features?.length > 0) {
        const [longitude, latitude] = data.features[0].geometry.coordinates;
        return { latitude, longitude };
      }
      return { latitude: "", longitude: "" };
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      return { latitude: "", longitude: "" };
    }
  };

  const fetchAppointments = async () => {
    try {
      const response = await fetch(`${API_URL}/api/job/fetch-single/${id}`, {
        method: "GET",
        headers: { Accept: "*/*", "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (response.status === 200) {
        const job = data.job;
        setFormData({
          address: job.address || "",
          postcode: job.postcode || "",
          job_cost: String(job.job_cost) || "",
          description: job.message || "",
          furtherDescription: job.futherDescription || "",
          latitude: job.map_location ? job.map_location.split(",")[0] : "",
          longitude: job.map_location ? job.map_location.split(",")[1] : "",
          referenceNo: job.referenceNo || "",
        
        });
        setCompletionReport({
          patTesting: job.functionalTesting,
          certificateIssue:job.certificateIssue
        })
        setEnableGeofencing(job?.enableGeofencing === true);
        setRadius(job.radius || 100);
        if (job.service_required) {
          setSelectedServices(
            job.service_required.split(",").map((e) => ({ label: e.trim(), value: e.trim() }))
          );
        }
        if (job.job_sended_to) {
          setElectricianListSelect(
            job.job_sended_to.map((id) => ({
              label: id.name,
              value: id.id,
            }))
          );
        }
        if (job.workforce) {
          setWorkforceListSelect(
            job.workforce.map((wf) => ({
              label: wf.fullName,
              value: wf.id,
            }))
          );
        }
        initializeQuill(
          "jobDescription",
          "Enter job description",
          (content) => {
            setFormData((prev) => ({ ...prev, description: content }));
          },
          job.message
        );
      
        initializeQuill(
          "invoiceItem",
          "Enter job further information",
          (content) => {
            setFormData((prev) => ({ ...prev, furtherDescription: content }));
          },
          job.futherDescription
        );
      }
    } catch (error) {
      console.error("Error fetching job:", error);
      setAlert({
        show: true,
        type: "danger",
        message: "Failed to load job details. Please try again.",
      });
    }
  };
  const electricianSelectOptions = useMemo(() => {
    return electricianList.filter((opt) => {
      const selectedInWorkforce = workforceListSelect.some(w => w.value === opt.value);
      const selectedInElectrician = electricianListSelect.some(e => e.value === opt.value);
      if (selectedInElectrician) return true; // keep selected item
      return !selectedInWorkforce;
    });
  }, [electricianList, electricianListSelect, workforceListSelect]);
  
  const workforceSelectOptions = useMemo(() => {
    return electricianList.filter((opt) => {
      const selectedInElectrician = electricianListSelect.some(e => e.value === opt.value);
      const selectedInWorkforce = workforceListSelect.some(w => w.value === opt.value);
      if (selectedInWorkforce) return true; // keep selected item
      return !selectedInElectrician;
    });
  }, [electricianList, electricianListSelect, workforceListSelect]);
  useEffect(() => {
    fetchElectrician();
    fetchCustomers();
    fetchServices();
    fetchAppointments();
  }, []);
  const quillRefs = {
    jobDescription: useRef(null),
    invoiceItem: useRef(null),
  };
  const quillInstances = {
    jobDescription: useRef(null),
    invoiceItem: useRef(null),
  };
  const fileInputRef = useRef(null);
  const initializeQuill = useCallback((refKey, placeholder, onTextChange, initialContent = "") => {
    const ref = quillRefs[refKey].current;
    if (ref && !quillInstances[refKey].current) {
      const quill = new Quill(ref, {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: "" }, { align: "center" }, { align: "right" }],
          ],
        },
        placeholder,
      });

      quill.root.setAttribute("dir", "ltr");
      quill.root.style.direction = "ltr";
      quill.root.style.textAlign = "left";

      const editor = ref.querySelector(".ql-editor");
      if (editor) {
        editor.setAttribute("dir", "ltr");
        editor.style.direction = "ltr";
        editor.style.textAlign = "left";
      }

      if (initialContent) {
        quill.root.innerHTML = initialContent;
      }

      quill.on("text-change", () => {
        onTextChange(quill.root.innerHTML);
      });

      quillInstances[refKey].current = quill;
    }
  }, []);

  useEffect(() => {
    const fetchSuggestions = async (query) => {
      if (!query) {
        setAddressSuggestions([]);
        return;
      }
      try {
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
            query
          )}.json?access_token=${MAPBOX_ACCESS_TOKEN}&country=GB`
        );
        const data = await response.json();
        if (data.features) {
          setAddressSuggestions(
            data.features.map((feature) => ({
              label: feature.place_name,
              value: feature.place_name,
              coordinates: feature.geometry.coordinates,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching address suggestions:", error);
      }
    };

    const handleAddressInput = (e) => {
      const value = e.target.value;
      setFormData((prev) => ({ ...prev, address: value, latitude: "", longitude: "" }));
      fetchSuggestions(value);
    };

    const input = addressInputRef.current;
    if (input) {
      input.addEventListener("input", handleAddressInput);
      return () => input.removeEventListener("input", handleAddressInput);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleAddressSelect = (selected) => {
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        address: selected.value,
        latitude: selected.coordinates[1],
        longitude: selected.coordinates[0],
      }));
      setAddressSuggestions([]);
      setErrors((prev) => ({ ...prev, address: null }));
    }
  };

  const handleChangeElectrician = (selected) => {
    setElectricianListSelect(selected || []);
    setErrors((prev) => ({ ...prev, electricians: null }));
  };

  const handleChangeWorkforce = (selected) => {
    setWorkforceListSelect(selected || []);
    setErrors((prev) => ({ ...prev, workforce: null }));
  };

  const handleChangeService = (selectedOptions) => {
    setSelectedServices(selectedOptions || []);
    setErrors((prev) => ({ ...prev, services: null }));
  };

  const closeAlert = () => {
    setAlert({ show: false, type: "", message: "" });
  };

  const onFormSubmission = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      setAlert({
        show: true,
        type: "danger",
        message: "Please correct the errors in the form.",
      });
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      let latitude = formData.latitude;
      let longitude = formData.longitude;
      const headerList = {
        Accept: "*/*",
        "Content-type": "application/json",
      };
      const bodyContent = JSON.stringify({
        referenceNo: formData.referenceNo,
        address: formData.address,
        postcode: formData.postcode,
        job_cost: formData.job_cost,
        service_required: selectedServices.map((e) => e.value).join(","),
        job_posted_to: electricianListSelect.map((e) => e.value).join(","),
        workforce_ids: workforceListSelect.map((w) => w.value).join(","),
        assigned_by: user.id,
        description: descriptionQuillRef.current ? descriptionQuillRef.current.root.innerHTML : formData.description,
        furtherDescription: furtherQuillRef.current ? furtherQuillRef.current.root.innerHTML : formData.furtherDescription,
        map_location: latitude && longitude ? `${latitude},${longitude}` : "",
        radius: radius,
        enableGeofencing: enableGeofencing ? 1 : 0,
        functionalTesting: completetionTesting.patTesting ? 1: 0,
        certificateIssue: completetionTesting.certificateIssue ? 1: 0,
        job_date_set: jobDateSet
      });
      const response = await fetch(`${API_URL}/api/job/update-single/${id}`, {
        method: "PUT",
        headers: headerList,
        body: bodyContent,
      });
      const data = await response.json();
      if (response.status === 201) {
        Swal.fire({
          title: "Information Updated",
          text: "Job information is successfully updated",
          icon: "success",
        });
      } else {
        setAlert({
          show: true,
          type: "danger",
          message: data.message || "Failed to update job. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error during submission:", error);
      setAlert({
        show: true,
        type: "danger",
        message: error.message || "An error occurred while processing your request.",
      });
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Edit Job" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-8 col-lg-10">
              <div className="card border">
                <div className="card-body">
                  <style>
                    {`
                      .quill-editor {
                        min-height: 200px;
                        background: #fff;
                        border-radius: 8px;
                        margin-bottom: 20px;
                      }
                      .ql-container {
                        border-radius: 0 0 8px 8px;
                      }
                      .ql-toolbar {
                        border-radius: 8px 8px 0 0;
                      }
                      @media (max-width: 576px) {
                        .quill-editor {
                          min-height: 150px;
                        }
                      }
                    `}
                  </style>
                  <form onSubmit={onFormSubmission} noValidate>
                    <div className="mb-20">
                      <label
                        htmlFor="referenceNo"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Reference No <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control radius-8 ${errors.referenceNo ? "is-invalid" : ""}`}
                        id="referenceNo"
                        name="referenceNo"
                        placeholder="Enter reference number"
                        value={formData.referenceNo}
                        onChange={handleInputChange}
                      />
                      {errors.referenceNo && <div className="invalid-feedback">{errors.referenceNo}</div>}
                    </div>
                    <div className="mb-20">
                      <label
                        htmlFor="address"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Job Location <span className="text-danger-600">*</span>
                      </label>
                      <div style={{ position: "relative" }}>
                        <input
                          type="text"
                          className={`form-control radius-8 ${errors.address ? "is-invalid" : ""}`}
                          id="address"
                          name="address"
                          placeholder="Enter address"
                          value={formData.address}
                          onChange={handleInputChange}
                          ref={addressInputRef}
                        />
                        {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                        {addressSuggestions.length > 0 && (
                          <ul
                            style={{
                              position: "absolute",
                              zIndex: 1000,
                              background: "white",
                              border: "1px solid #ccc",
                              width: "100%",
                              listStyle: "none",
                              padding: 0,
                              maxHeight: "200px",
                              overflowY: "auto",
                              borderRadius: "4px",
                            }}
                          >
                            {addressSuggestions.map((suggestion, index) => (
                              <li
                                key={index}
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                  backgroundColor: "#fff",
                                }}
                                onClick={() => handleAddressSelect(suggestion)}
                                onMouseEnter={(e) => (e.target.style.backgroundColor = "#f8f9fa")}
                                onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
                              >
                                {suggestion.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                    <div className="mb-20">
                      <label
                        htmlFor="postcode"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Postcode
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        id="postcode"
                        name="postcode"
                        placeholder="Enter postcode"
                        value={formData.postcode}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="mb-20">
                      <label
                        htmlFor="service"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Select Services Required <span className="text-danger-600">*</span>
                      </label>
                      <Select
                        id="service"
                        options={serviceOptions}
                        isMulti
                        onChange={handleChangeService}
                        value={selectedServices}
                        className={errors.services ? "is-invalid" : ""}
                      />
                      {errors.services && <div className="invalid-feedback">{errors.services}</div>}
                    </div>
                    <div className="mb-20">
                      <label
                        htmlFor="select"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Select Electricians <span className="text-danger-600">*</span>
                      </label>
                      <Select
                      id="select"
                      options={electricianSelectOptions}
                      onChange={handleChangeElectrician}
                      isMulti
                      value={electricianListSelect}
                      className={errors.electricians ? "is-invalid" : ""}
                    />
                      {errors.electricians && <div className="invalid-feedback">{errors.electricians}</div>}
                    </div>
                    <div className="mb-20">
                      <label
                        htmlFor="workforceSelect"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Select Workforce <span className="text-danger-600">*</span>
                      </label>
                      <Select
                      id="workforceSelect"
                      options={workforceSelectOptions}
                      onChange={handleChangeWorkforce}
                      isMulti
                      value={workforceListSelect}
                      className={errors.workforce ? "is-invalid" : ""}
                      placeholder="Select workforce members"
                    />
                      {errors.workforce && <div className="invalid-feedback">{errors.workforce}</div>}
                    </div>
       
  <div className="mb-3">
                          <label htmlFor="jobDateSet" className="form-label">
                            Job Date <span className="text-danger">*</span>
                          </label>
                          <input
                            type="datetime-local"
                            id="jobDateSet"
                            name="jobDateSet"
                            className="form-control"
                            value={jobDateSet}
                            onChange={(e) => setJobDateSet(e.target.value)}
                          />
                          <div className="form-text">Select the date and time for this job.</div>
                        </div>
                    <div className="mb-4 mt-3">
                      <div className="form-check form-switch">
                        <Switch
                          className="form-check-input"
                          type="checkbox"
                          id="geofencingSwitch"
                          checked={enableGeofencing}
                          onChange={(e) => setEnableGeofencing(e)}
                        />
                        <label className="form-check-label" htmlFor="geofencingSwitch">
                          &nbsp; &nbsp;Enable Geofencing
                        </label>
                      </div>
                    </div>
                    {enableGeofencing && (
                      <>
                        <div className="mb-4">
                          <label htmlFor="radiusInput" className="form-label">
                            Geofence Radius (meters)
                          </label>
                          <input
                            type="number"
                            id="radiusInput"
                            className="form-control"
                            min="50"
                            max="5000"
                            value={radius}
                            onChange={(e) => setRadius(parseInt(e.target.value) || 100)}
                          />
                          <div className="form-text">
                            Set the radius for the geofence area around the location.
                          </div>
                        </div>
                        {loadError && (
                          <div className="alert alert-danger">
                            Error loading Google Maps. Please try again later.
                          </div>
                        )}
                        {!isLoaded ? (
                          <div>Loading Google Maps...</div>
                        ) : (
                          <div className="mb-4">
                            <GoogleMap
                              mapContainerStyle={mapContainerStyle}
                              center={mapCenter}
                              zoom={14}
                              options={{
                                streetViewControl: false,
                                mapTypeControl: false,
                                fullscreenControl: false,
                              }}
                            >
                              {markerPosition && (
                                <>
                                  <Marker position={markerPosition} draggable={false} />
                                  <Circle
                                    center={markerPosition}
                                    radius={radius}
                                    options={{
                                      strokeColor: "#FF0000",
                                      strokeOpacity: 0.8,
                                      strokeWeight: 2,
                                      fillColor: "#FF0000",
                                      fillOpacity: 0.35,
                                    }}
                                  />
                                </>
                              )}
                            </GoogleMap>
                            <div className="form-text">
                              Map showing the job location and geofence area.
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mb-20">
                      <label
                        htmlFor="desc"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Description
                      </label>
                      <div className="quill-editor">
                         <div
                                ref={quillRefs.jobDescription}
                                className={`ql-container ${
                                  errors.description ? "is-invalid" : ""
                                }`}
                              />
                      </div>
                    </div>
                    <div className="mb-20">
                      <div style={{display:'flex', justifyContent:'space-between'}}>
                      <label
                       className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Functional Tesing
                      </label>
                         <div style={{}}>
                         <button onClick={(e)=>{e.preventDefault(); setCompletionReport((prev)=>({...prev, patTesting: true}))}} className={completetionTesting.patTesting === true ? "btn btn-success": "btn btn-outline-success" } style={{marginRight:10}}>Yes</button>
                          <button onClick={(e)=>{e.preventDefault(); setCompletionReport((prev)=>({...prev, patTesting: false}))}} className={completetionTesting.patTesting === false ? "btn btn-danger": "btn btn-outline-danger" }>No</button>
                          </div>
                          </div>
                      <div style={{display:'flex', justifyContent:'space-between',marginTop:10}}>
                      <label
                       className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Electricial Certificate Issue
                      </label>
                         <div style={{}}>
                         <button type="button" onClick={(e)=>{e.preventDefault(); setCompletionReport((prev)=>({...prev, certificateIssue: true}))}} className={completetionTesting.certificateIssue === true ? "btn btn-success": "btn btn-outline-success" } style={{marginRight:10}}>Yes</button>
                          <button type="button" onClick={(e)=>{e.preventDefault(); setCompletionReport((prev)=>({...prev, certificateIssue: false}))}} className={completetionTesting.certificateIssue === false ? "btn btn-danger": "btn btn-outline-danger" }>No</button>
                          </div>
                          </div>
                      </div>
                    <div className="mb-20">
                      <label
                        htmlFor="furtherDesc"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Further Information
                      </label>

                      <div className="quill-editor">
                        <div ref={quillRefs.invoiceItem} style={{ minHeight: "200px" }} />
                      </div>
                    </div>
                    {alert.show && (
                      <div className={`alert alert-${alert.type} alert-dismissible fade show mb-4`} role="alert">
                        {alert.message}
                        <button
                          type="button"
                          className="btn-close"
                          onClick={closeAlert}
                          aria-label="Close"
                        ></button>
                      </div>
                    )}
                    <div className="d-flex align-items-center justify-content-center gap-3">
                      <button
                        type="submit"
                        style={{ color: "white" }}
                        className="btn bg-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      >
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default EditAppointmentPage;